import * as ActionTypes from '../constants';
import { baseUrl } from '.';
import axios from 'axios';
import { getUserToken } from './getUserToken';

const dispatchRequestCourseMaterial = () => ({
    type: ActionTypes.REQUEST_COURSE_MATERIAL
})

const dispatchReceivedCourseMaterial = res => ({
    type: ActionTypes.RECEIVED_COURSE_MATERIAL,
    res
})

const dispatchErrorCourseMaterial = err => ({
    type: ActionTypes.ERROR_COURSE_MATERIAL,
    err
})

const dispatchClearCourseMaterial = () => ({
    type: ActionTypes.CLEAR_COURSE_MATERIAL
})

export const clearAllCourseMaterialData = () => dispatchClearCourseMaterial();


export const getCourseMaterial = lessonPlannerId => dispatch => {
    getUserToken().then(res => {
        const data = {
            lesson_planner_id: lessonPlannerId
        }
        dispatch(dispatchRequestCourseMaterial());               
        const options = {
            method: 'post',
            url: `${baseUrl}/api/materials`,
            data: data,
            headers: {
                Authorization: `Bearer ${res}`,
                // "Access-Control-Allow-Origin": "*",
                            
            }
        }         
        return axios(options).then( ({data}) => {
            dispatch(dispatchReceivedCourseMaterial(data))
        })
    }).catch(e => {
        dispatch(dispatchErrorCourseMaterial(e.response));         
    })
    

}